import type { MouseEvent } from "react";
import type { GuardedLinkProps } from "./GuardedLink.types";
import {
  Link
} from "../../components";
import { ButtonDigited } from "../../components/Button/Button.variants";

/**
 * the GuardedLink component is meant for buttons which provide access to
 * history based navigation between pages and implements a shutoff by reading
 * the mandatory boolean return value of the onClick handler
 */
export function GuardedLink({
  alignSelf,
  children,
  disableLink = false,
  href,
  onClick,
  target,
  state,
  disabled,
  dataTestId,
  component,
  //type,
  ...props
} : GuardedLinkProps) {

  return (
    <Link
      disabled={ disableLink }
      alignSelf={ alignSelf }
      href={ href }
      state={ state }
      sx={ props.sx }
      tabIndex={ -1 }
      target={ target }
      aria-disabled={ disabled || undefined }
      onClick={ (clickEvent: MouseEvent<HTMLAnchorElement>) => {
        // the disabled button has pointer-events: none, so the click
        // reaches the anchor: block the navigation here
        disabled && clickEvent.preventDefault();
      } }
      { ...(component ? { component } : {}) }
    >
      <ButtonDigited
        dataTestId={ dataTestId  }
        typology="primary"
        buttonSize="md"
        aria-label={ children as string }
        onClick={ (clickEvent: MouseEvent<HTMLButtonElement>) => {
          // legacy code, guarded links should not navigate
          // instead use navigation in component by checking auth store flag
          const validResult = onClick ? onClick(clickEvent) : true;
          !validResult && clickEvent.preventDefault();

        } }
        disabled={ disabled }
        text={ children }
      ></ButtonDigited>
    </Link>
  );
}
